import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BookOpen, Library, Layers } from "lucide-react";

const SUBJECTS = [
  { key: "matematik", label: "Matematik" },
  { key: "turkce", label: "Türkçe" },
  { key: "fen", label: "Fen Bilimleri" },
  { key: "inkilap", label: "İnkılap" },
  { key: "din", label: "Din Kültürü" },
  { key: "ingilizce", label: "İngilizce" },
];

export default function KaynaklarPage() {
  const [subject, setSubject] = useState("all");
  const [level, setLevel] = useState("all");
  const [items, setItems] = useState([]);
  const [labels, setLabels] = useState({});
  const [note, setNote] = useState("");

  const load = (s, l) => {
    const params = new URLSearchParams();
    if (s && s !== "all") params.set("subject", s);
    if (l && l !== "all") params.set("level", l);
    api.get(`/resources?${params.toString()}`).then((r) => {
      setItems(r.data.resources || []);
      setLabels(r.data.level_labels || {});
      setNote(r.data.note || "");
    });
  };

  useEffect(() => { load(subject, level); }, [subject, level]);

  return (
    <div className="space-y-5 ela-fade-in" data-testid="kaynaklar-page">
      <div>
        <div className="flex items-center gap-2 text-indigo-600 text-xs uppercase tracking-wider font-semibold">
          <Library className="w-3.5 h-3.5" /> Önerilen Kaynaklar
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 mt-1">Çalışma Kaynak Önerileri</h1>
        <p className="text-sm text-slate-500 mt-1">{note}</p>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <Select value={subject} onValueChange={setSubject}>
          <SelectTrigger className="rounded-xl h-11" data-testid="filter-subject">
            <SelectValue placeholder="Ders" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tüm Dersler</SelectItem>
            {SUBJECTS.map((s) => <SelectItem key={s.key} value={s.key}>{s.label}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={level} onValueChange={setLevel}>
          <SelectTrigger className="rounded-xl h-11" data-testid="filter-level">
            <SelectValue placeholder="Seviye" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tüm Seviyeler</SelectItem>
            {Object.entries(labels).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {items.map((r, i) => (
          <Card key={i} className="p-4 rounded-2xl border-slate-200 ela-card-hover" data-testid={`resource-${i}`}>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                {r.type === "deneme" ? <Layers className="w-4 h-4" /> : <BookOpen className="w-4 h-4" />}
              </div>
              <div className="min-w-0">
                <div className="font-heading font-semibold text-slate-900">{r.title}</div>
                <div className="flex gap-1.5 my-1.5">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
                    {SUBJECTS.find((s) => s.key === r.subject_key)?.label}
                  </span>
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700">
                    {labels[r.level]}
                  </span>
                </div>
                <p className="text-xs text-slate-600">{r.desc}</p>
              </div>
            </div>
          </Card>
        ))}
        {items.length === 0 && (
          <div className="col-span-full text-center text-sm text-slate-500 p-8">
            Bu filtre için kaynak yok.
          </div>
        )}
      </div>
    </div>
  );
}
